export default "__VITE_ASSET__BhdofwSH__"